import { RESET_APPLICATION_DETAIL } from '../constants';

import {
    FETCH_APPLICATION_GUIDES,
    FETCH_APPLICATION_GUIDES_SUCCESS,
    FETCH_APPLICATION_GUIDES_ERROR,
    REMOVE_GUIDE_SUCCESS,
    DUPLICATE_GUIDE_SUCCESS,
    EDIT_GUIDE_HOST_SUCCESS,
    SET_GUIDES_SEARCH_TERM,

    // Create guide
    CREATE_GUIDE_SUCCESS,
    CREATE_GUIDE_ERROR,

    // Edit guide
    UPDATE_GUIDE_SUCCESS,

    // Fetch guide rules
    FETCH_GUIDE_RULES_SUCCESS,
    UPDATE_GUIDE_RULES_SUCCESS,
    UPDATE_TOUR_SUCCESS,

    // Fetch attribute for rule
    FETCH_ATTRIBUTES_FOR_RULE_REQUEST,
    FETCH_ATTRIBUTES_FOR_RULE_SUCCESS,
    FETCH_ATTRIBUTES_FOR_RULE_ERROR,

    // Fetch context (RLL) options for Adopt rule options
    FETCH_CONTEXT_OPTIONS_FOR_RULE_REQUEST,
    FETCH_CONTEXT_OPTIONS_FOR_RULE_SUCCESS,
    FETCH_CONTEXT_OPTIONS_FOR_RULE_ERROR,
} from './constants';

const initialState = {
    isLoading: false,
    hasError: false,
    data: [],
    rulesAttribute: {
        data: [],
        isLoading: true,
        isFailed: false,
    },
    rulesContextOptions: {
        data: {
            roles: [],
            languages: [],
            locations: [],
        },
        isLoading: false,
        isFailed: false,
    },
    searchTerm: '',
};

const duplicateGuide = (arr, newItem, sourceGuideId) => {
    const sourceGuideIndex = arr.findIndex((guide) => guide.id === sourceGuideId);
    return [...arr.slice(0, sourceGuideIndex + 1), newItem, ...arr.slice(sourceGuideIndex + 1)];
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case RESET_APPLICATION_DETAIL:
            return initialState;

        case FETCH_APPLICATION_GUIDES:
            return {
                ...state,
                hasError: false,
                isLoading: true,
                data: [],
            };

        case DUPLICATE_GUIDE_SUCCESS:
            return {
                ...state,
                data: duplicateGuide(state.data, payload.data, payload.sourceGuideId),
            };

        case FETCH_APPLICATION_GUIDES_ERROR:
            return {
                ...state,
                hasError: true,
                isLoading: false,
            };

        case FETCH_APPLICATION_GUIDES_SUCCESS:
            return {
                ...state,
                hasError: false,
                isLoading: false,
                data: payload.data,
            };

        case SET_GUIDES_SEARCH_TERM:
            return {
                ...state,
                searchTerm: payload.searchTerm,
            };

        case REMOVE_GUIDE_SUCCESS:
            return {
                ...state,
                data: state.data.filter((guide) => guide.id !== payload),
            };

        case EDIT_GUIDE_HOST_SUCCESS:
            return {
                ...state,
                data: payload.isSameApplication
                    ? state.data.map((guide) => {
                          if (guide.id !== payload.guideId) {
                              return guide;
                          }

                          return {
                              ...guide,
                              initialUrl: payload.data.initialUrl,
                          };
                      })
                    : state.data.filter((guide) => guide.id !== payload.guideId),
            };

        case UPDATE_GUIDE_SUCCESS:
            return {
                ...state,
                data: state.data.map((guide) => {
                    if (guide.id !== payload.guide.id) {
                        return guide;
                    }
                    const { name, description, initialUrl } = payload.data;
                    return { ...guide, name, description, initialUrl };
                }),
            };

        case UPDATE_GUIDE_RULES_SUCCESS:
            return {
                ...state,
                data: state.data.map((guide) => {
                    if (guide.id !== payload.guideId) {
                        return guide;
                    }

                    return { ...guide, graph: payload.data.graph };
                }),
            };

        case CREATE_GUIDE_SUCCESS:
            return {
                ...state,
                data: [payload, ...state.data],
            };

        case CREATE_GUIDE_ERROR:
            return {
                ...state,
                hasError: true,
                isLoading: false,
            };

        case FETCH_GUIDE_RULES_SUCCESS:
            return {
                ...state,
                data: state.data.map((guide) => {
                    if (guide.id !== payload.guideId) {
                        return guide;
                    }

                    return {
                        ...guide,
                        graph: payload.payload.graph,
                        editorSettings: payload.payload.editorSettings,
                    };
                }),
            };

        case UPDATE_TOUR_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasError: false,
                data: state.data.map((guide) =>
                    guide.id === payload.id
                        ? {
                              ...guide,
                              graph: payload.data.graph,
                              editorSettings: payload.data.editorSettings,
                          }
                        : guide
                ),
            };

        case FETCH_ATTRIBUTES_FOR_RULE_REQUEST:
            return {
                ...state,
                rulesAttribute: {
                    data: [],
                    isLoading: true,
                    isFailed: false,
                },
            };

        case FETCH_ATTRIBUTES_FOR_RULE_SUCCESS:
            return {
                ...state,
                rulesAttribute: {
                    data: payload,
                    isLoading: false,
                    isFailed: false,
                },
            };

        case FETCH_ATTRIBUTES_FOR_RULE_ERROR:
            return {
                ...state,
                rulesAttribute: {
                    data: [],
                    isLoading: false,
                    isFailed: true,
                },
            };

            
        case FETCH_CONTEXT_OPTIONS_FOR_RULE_REQUEST:
            return {
                ...state,
                rulesContextOptions: {
                    data: initialState.rulesContextOptions.data,
                    isLoading: true,
                    isFailed: false,
                },
            };

        case FETCH_CONTEXT_OPTIONS_FOR_RULE_SUCCESS:
            return {
                ...state,
                rulesContextOptions: {
                    data: payload,
                    isLoading: false,
                    isFailed: false,
                },
            };

        case FETCH_CONTEXT_OPTIONS_FOR_RULE_ERROR:
            return {
                ...state,
                rulesContextOptions: {
                    data: initialState.rulesContextOptions.data,
                    isLoading: false,
                    isFailed: true,
                },
            };
        default:
            return state;
    }
};

export default reducer;
